/* eslint-disable no-console */

import axios from 'axios';

let blockRequests = false;
const originalFetch = window.fetch;

export const setAPIBlock = (shouldBlock) => {
  blockRequests = shouldBlock;
  console.log(`API Blocking is now ${shouldBlock ? 'ENABLED' : 'DISABLED'}`);
};

// Intercept fetch
window.fetch = async (...args) => {
  if (blockRequests) {
    console.warn(' Blocked fetch request to:', args[0]);
    return new Response(null, {
      status: 403,
      statusText: 'Blocked by interceptor',
    });
  }
  return originalFetch(...args);
};

// Intercept axios
axios.interceptors.request.use(
  (config) => {
    if (blockRequests) {
      console.warn(' Blocked axios request to:', config.url);
      // Throwing here will prevent the request
      return Promise.reject(new Error('Blocked by interceptor'));
    }
    return config;
  },
  (error) => Promise.reject(error)
);
